import { inject, Injectable, Injector, Type, ViewContainerRef } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MyBalanceService {
  private _componentRef: Type<unknown>;
  private _myBalanceContainerRef: ViewContainerRef;

  private readonly _injector = inject(Injector);

  setMyBalanceRef(myBalanceContainerRef: ViewContainerRef): void {
    if (!this._componentRef) {
      return;
    }

    this._myBalanceContainerRef = myBalanceContainerRef;

    this._myBalanceContainerRef.createComponent(this._componentRef, {
      injector: this._injector,
    });
  }

  showMyBalanceComponent<T>(component: Type<T>): void {
    this._componentRef = component;
  }
}
